import axios from 'axios';

const api = axios.create({
  baseURL: 'https://amzmp.com.br/cliente/franceschi/lp/lp/recebe-lp-priscila.php',
  // baseURL: 'http://localhost/priscila_rocco_backend',
});

export default api;
